import React from 'react';
import PropTypes from 'prop-types';
import TagManager from 'react-gtm-module';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';
import {
  selectRegistrationCurrentStep,
  selectRegistrationInfo,
} from '../../../../../../store/selectors';
import {
  setRegistrationCurrentStep,
  setRegistrationInfo,
} from '../../../../../../store/actions/registration';
import {
  constructGTM,
  preparePhoneNumberForBackend,
  preparePhoneNumberForFrontend,
} from '../../../../../../utilities/helpers';
import RegistrationForm from '../../../RegistrationForm';

const propTypes = {
  onSetRegistrationCurrentStep: PropTypes.func.isRequired,
  onSetRegistrationInfo: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string,
    header: PropTypes.string,
    main: PropTypes.string,
    actionsRow: PropTypes.string,
    inner: PropTypes.string,
  }).isRequired,
  registrationInfo: PropTypes.object.isRequired,
};

export const StepOne = props => {
  const {
    classes,
    onSetRegistrationCurrentStep,
    onSetRegistrationInfo,
    registrationInfo,
  } = props;

  const handleFormSubmit = values => {
    const formValues = { ...values };

    // add country code to primary phone number
    formValues['custom:personalPhone'] = preparePhoneNumberForBackend(
      formValues['custom:personalPhone'],
    );

    // add country code to mobile number if it is not empty
    if (formValues['custom:mobileNumber']) {
      formValues['custom:mobileNumber'] = preparePhoneNumberForBackend(
        formValues['custom:mobileNumber'],
      );
    }

    // Log submit event to GTM
    TagManager.initialize(
      constructGTM({
        dataLayer: {
          event: 'registration_myhardies',
          step: 'Business Details',
          stepcnt: '2',
        },
      }),
    );

    onSetRegistrationInfo(formValues);
    onSetRegistrationCurrentStep(1);
  };

  const getInitialValues = () => {
    const initialValues = {
      ...registrationInfo,
    };

    if (initialValues['custom:personalPhone']) {
      initialValues['custom:personalPhone'] = preparePhoneNumberForFrontend(
        initialValues['custom:personalPhone'],
      );
    }

    if (initialValues['custom:mobileNumber']) {
      initialValues['custom:mobileNumber'] = preparePhoneNumberForFrontend(
        initialValues['custom:mobileNumber'],
      );
    }

    return initialValues;
  };

  return (
    <div>
      <div className={classes.instruction}>
        Please complete and submit the details below.
      </div>
      <RegistrationForm
        onSubmit={handleFormSubmit}
        initialValues={getInitialValues()}
      />
    </div>
  );
};

StepOne.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
  currentStep: selectRegistrationCurrentStep(),
  registrationInfo: selectRegistrationInfo(),
});

const mapDispatchToProps = dispatch => ({
  onSetRegistrationInfo: info => dispatch(setRegistrationInfo(info)),
  onSetRegistrationCurrentStep: step =>
    dispatch(setRegistrationCurrentStep(step)),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(StepOne),
);
